<template>
  <div class="main-products bg-center">
    <div class="products-info">
      <div class="left-bg-title bg-center pd10tb">主要产品</div>
      <div class="main-pic">
        <div class="item" v-if="index<5"  v-for="(item,index) in productList"><img :src="item" alt/></div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAreaProductList} from "../../api/home.js";
import {mapGetters} from "vuex";
export default {
  props: ["renderArray"],
 data() {
    return {
      productList:[]
    }; 
  },
  watch: {
    // $route(to, from) {
    //   if (/\/company/gi.test(to.path)) {
    //     this.productList = [];                         
    //     this.getLists(this.orgIdNum);
    //   }
    // }
	async orgIdNum(val)
	{
		if(val != 0)
		{
			this.getLists(val);
		}
	}
  },
  mounted() {
    this.getLists(this.orgIdNum);
  },
  methods: {
    getLists(orgId) {
	  this.productList = []; 	
      getAreaProductList(orgId)
        .then(res => {
          if (res.data) {
			let result =   res.data.records;
			if(result != '')
			{
				result.forEach((item,index) => {
					this.productList.push(item.mainImg)
					if(item.productImg != '')
					{
						item.productImg.forEach(items => {
							this.productList.push(items)
						})
					}
				})
			}
            
          }
        })
        .catch(err => {});
    }
  },
  computed:{
  	  ...mapGetters(['orgIdNum'])
  }
};
</script>

<style lang='less'>
.main-products {
  position: relative;
  pointer-events: all;
  width: 100%;
  height: 100%;
  max-width: 1007px;
  background-image: url(../../assets/images/products-info.png);

  .main-pic {
    overflow: hidden;
    padding: 20px 15px 0 15px;
    display: flex;
    justify-content: space-around;
    .item {
      position: relative;
      display: block;
      width: 20%;
      height: 100%;
      margin-top: 20px;
      padding: 10px;
      img {
        display: block;
        width: 100%;
        height: 138px;
        object-fit: cover;
        object-position: center;
      }
    }
  }
}
</style>